import {Component, Inject, OnInit, output} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {locationsOptions, SortOptions} from "./campaigns-filter";
import {distinctUntilChanged} from "rxjs/operators";
import {debounceTime, takeUntil} from "rxjs";
import {NumericRange, RangeSliderComponent, RangeSliderType} from './range-slider/range-slider.component';
import {ClosableBottomSheetComponent} from '../closable-bottom-sheet/closable-bottom-sheet.component';
import {
  ClosableBottomSheetHandleComponent
} from '../closable-bottom-sheet/closable-bottom-sheet-handle/closable-bottom-sheet-handle.component';
import {RadioButtonsQuestionComponent} from '../radio-buttons-question/radio-buttons-question.component';
import {MatButton} from '@angular/material/button';
import {TranslocoDirective} from '@jsverse/transloco';

@Component({
  selector: 'app-campaigns-filters',
  templateUrl: './campaigns-filters.component.html',
  styleUrl: './campaigns-filters.component.scss',
  imports: [
    ClosableBottomSheetHandleComponent,
    ReactiveFormsModule,
    RadioButtonsQuestionComponent,
    MatButton,
    RangeSliderComponent,
    TranslocoDirective
  ]
})
export class CampaignsFiltersComponent extends ClosableBottomSheetComponent implements OnInit {

  formChange = output<CampaignsFilter>();
  //Not used at the moment. Clarify design.
  filterCounter = 0;
  form: FormGroup;
  sortOptions = locationsOptions;
  protected readonly RangeSliderType = RangeSliderType;

  constructor(private bottomSheetRef: MatBottomSheetRef<CampaignsFiltersComponent>, private fb: FormBuilder,
              @Inject(MAT_BOTTOM_SHEET_DATA) public data: CampaignFilterData, bottomSheet: MatBottomSheet) {
    super(bottomSheet);
    const state = data.state;
    this.form = this.fb.group({
      sort: [state?.sort || this.sortOptions[0]?.value],
      merchantId: [state?.merchantId || undefined],
      loyaltyScore: [state?.loyaltyScore || undefined],
      amount: [state?.amount || undefined],
    });
  }

  ngOnInit() {
    this.filterCounter = countFormValues(this.form.value);
    this.form.valueChanges
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$), debounceTime(200))
      .subscribe((formValues) => {
        const campaignFilter = this.removeUndefinedFields(formValues);
        this.formChange.emit(campaignFilter);
        this.filterCounter = countFormValues(campaignFilter);
      });
  }

  clearFilters(): void {
    this.form.reset({
      sort: SortOptions.MOST_RECENT,
      categoryId: undefined,
      merchantId: undefined,
      loyaltyScore: undefined,
      amount: undefined
    });
  }

  apply(): void {
    this.bottomSheetRef.dismiss(this.form.value);
  }

  private removeUndefinedFields(campaignFilter: CampaignsFilter): CampaignsFilter {
    Object.keys(campaignFilter).forEach((key: string) => (campaignFilter as any)[key] === undefined ? delete (campaignFilter as any)[key] : {});
    return campaignFilter;
  }

}

//Subtract one because we want to exclude sort field, which is always included;
function countFormValues(formValues: any): number {
  return Object.values(formValues).filter(value => !!value).length - 1;
}


export interface CampaignFilterData {
  settings: CampaignsFilterSettings,
  state: CampaignsFilter

}

export interface CampaignsFilterSettings {
  showLoyalty: boolean
}

export interface CampaignsFilter {
  sort: SortOptions,
  categoryId?: string,
  merchantId?: string,
  loyaltyScore?: NumericRange,
  amount?: NumericRange,
  geoBounds?: GeoBounds
  sortByDistance?: boolean;
}

export interface GeoBounds {
  southWest: GeoPoint;
  northEast: GeoPoint;
}

export interface GeoPoint {
  latitude: number,
  longitude: number
}
